import { gecerliHedefler } from './hedefleme.js'
import { durusDegistirilebilirMi } from './durus.js'
import { kullanilabilirBeceriler, durusaGoreBeceriler } from './beceri.js'
import type { Beceri } from './beceri.js'
import type { SavasDurumu, Kahraman } from './tipler.js'

export type KahramanKomutu =
  | { tip: 'durus_degistir' }
  | { tip: 'beceri'; beceriKodu: string }

export interface TurGirdisi {
  /** Birim id → o turda uygulanacak komutlar. Verilmeyen kahraman yapay zekâ oynar. */
  komutlar: Record<string, KahramanKomutu[]>
}

/** Kahramanın o an karşılayabildiği en pahalı beceri. */
export function enIyiBeceri(k: Kahraman): Beceri {
  const secenekler = kullanilabilirBeceriler(k.durus, k.ofke)
  return secenekler.reduce((en, b) => (b.ofkeMaliyeti > en.ofkeMaliyeti ? b : en))
}

/** Duruşun bedava temel becerisi — geçersiz komutlarda buraya düşülür. */
export function temelBeceri(k: Kahraman): Beceri {
  const bedava = durusaGoreBeceriler(k.durus).filter((b) => b.ofkeMaliyeti === 0)
  return bedava[0]!
}

/**
 * Yapay zekâ komutu: vuracak hedef kalmadıysa duruş değiştirir,
 * sonra karşılayabildiği en pahalı beceriyi kullanır.
 */
export function yapayZekaKomutu(durum: SavasDurumu, k: Kahraman): KahramanKomutu[] {
  const komutlar: KahramanKomutu[] = []
  const beceri = enIyiBeceri(k)
  if (
    durusDegistirilebilirMi(k) &&
    gecerliHedefler(durum, k, beceri.safDeler).length === 0
  ) {
    komutlar.push({ tip: 'durus_degistir' })
  }
  komutlar.push({ tip: 'beceri', beceriKodu: enIyiBeceri(k).kod })
  return komutlar
}
